import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import IconTooltip from '#client/components/IconTooltip';

function CardAddressTitle() {
  return (
    <Stack
      alignItems="center"
      direction="row"
      gap="4px"
      mt="32px"
    >
      <Text
        size="xl"
        weight="medium"
      >
        Card address
      </Text>
      <Box>
        <IconTooltip
          content="The physical address on file at the issuing bank"
          icon={<ErrorOutlineIcon color="blue" />}
        />
      </Box>
    </Stack>
  );
}

export default CardAddressTitle;
